export default function Subtitles({ subtitles, isKeyboardOpen, fontSize }) {
  return (
    <div
      style={{
        position: "absolute",
        bottom: isKeyboardOpen ? "5vh" : "20vh",
        left: "50%",
        transform: "translateX(-50%)",
        color: "#282935", // Color according to the provided style
        backgroundColor: "rgba(255, 255, 255, 0.50)", // Transparent white background
        padding: "10px",
        borderRadius: "1px", // Border radius to match the screenshot
        width: "80%",
        fontSize: fontSize || "16px", // Default font size to 16px if not provided
        textAlign: "center",
        backdropFilter: "blur(17.2px)", // Apply blur effect to the background
        WebkitBackdropFilter: "blur(17.2px)", // Safari support
        fontFamily: "Inter, sans-serif", // Font family to 'Inter'
        fontWeight: "700", // Font weight to 700
        lineHeight: "normal", // Line height to normal
        letterSpacing: "-0.16px", // Adjust letter spacing
      }}
    >
      {subtitles}
    </div>
  );
}
